import React from 'react';

var FairnessButton = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'security' : _b, onClick = _a.onClick;
    return (React.createElement("div", { className: 'pgc-right-head-icon-cont', onClick: onClick },
        React.createElement("i", { className: "icon-".concat(iconName) })));
};

export { FairnessButton };
